import React from "react";
import { useLanguageContext } from "../../contexts/LanguageContext";
import "./Team.css";
import SEO from "../seo/SEO";

const Team: React.FC = () => {
  const { content } = useLanguageContext();

  return (
    <>
      <SEO 
        title={content.team.seo.title} 
        description={content.team.seo.description} 
      />
    
      <section id="team" className="team-section">
        <div className="container">
          <div className="team-header text-center">
            <p className="section-subtitle">{content.team.subtitle}</p>
            <h2 className="section-title">{content.team.title}</h2>
            <p className="section-description">{content.team.description}</p>
          </div>

          <div className="team-grid">
            {content.team.members.map((member: any, index: number) => (
              <div key={index} className="team-member-card card">
                <a
                  className="member-avatar-wrapper"
                  href={member.linkedin}
                  target="_blank"
                >
                  <img className="member-avatar" src={member.image} />
                </a>
                <h3 className="member-name">{member.name}</h3>
                <p className="member-role">{member.role}</p>
                <p className="member-description">{member.description}</p>
                <div className="social-icon-wrapper">
                  <a
                    href={member.linkedin}
                    className="social-icon"
                    target="_blank"
                  >
                    <img src="assets/icons/linkedin.svg"></img>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Team;
